<div class="templates background-white scrollable-container" #scrollableContainer (scroll)="onScroll($event)" appOverscroll>
  <div class="filter-and-add">
    <div class="invoice-filter">
      <!-- <mat-form-field [hideRequiredMarker]="true" style="height: 48px; width: 230px" appearance="outline">
        <mat-label>Search by title</mat-label>
        <input
          matInput
          #input
          [(ngModel)]="searchTemplateInput"
          (focus)="isInputFocused = true"
          (blur)="isInputFocused = false"
        />
          <mat-icon style="cursor: pointer; margin-top: 5px;" *ngIf="showClearIcon" matSuffix (click)="clearSearch()">close</mat-icon>
        <mat-icon matSuffix *ngIf="!showClearIcon && !isInputFocused">search</mat-icon>
      </mat-form-field> -->
      <mat-form-field
        [hideRequiredMarker]="true"
        style="height: 48px; width: 230px"
        appearance="outline"
        [ngClass]="{ 'small-placeholder': isInputFocused }"
      >
        <mat-label [ngClass]="'custom-label'">Search by title </mat-label>
        <input
     
          matInput
          #input
          [(ngModel)]="searchTemplateInput"
          (focus)="isInputFocused = true"
          (blur)="isInputFocused = false"
          (input)="toggleIcon()"
        />
        <mat-placeholder style="color: brown"
          >Enter your name here</mat-placeholder
        >
        <mat-icon
          style="cursor: pointer; margin-top: 5px"
          *ngIf="showClearIcon"
          matSuffix
          (click)="clearSearch()"
          >close</mat-icon
        >
        <mat-icon matSuffix *ngIf="!showClearIcon && !isInputFocused"
          >search</mat-icon
        >
      </mat-form-field>
    </div>
    <div class="add-invoice">
      <button mat-button class="primary-button custom-button" (click)="addNewTemplate()" style="width: 202px; display: flex; gap: 8px">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6 14V8H0V6H6V0H8V6H14V8H8V14H6Z" fill="white" />
        </svg>
        &nbsp;<span>{{ "createTemplate" | translate }}</span>
      </button>
    </div>
  </div>

  <div class="template-list" *ngIf="!loading">
    <table class="si-table">
      <tbody>
        <tr
          class="show-on-hover pointer"
          (click)="editTemplate(template)"
          *ngFor="
            let template of templates
          "
        >
          <td>
            <span class="template-name"
              >{{ template._name }}
             </span
            >
            <p class="template-description" *ngIf="template._description">
              {{ template._description }}
            </p>
          </td>
          <td class="text-right">
            <div class="operations">
              <div
                class="icon-wrapper"
                (click)="$event.stopPropagation(); deleteTemplate(template)"
                (mouseover)="isHovered = true"
                (mouseleave)="isHovered = false"
              >
              <svg
              width="24"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              [style.fill]="isHovered ? '#1E31CF' : '#27272C'"
            >
              <path
                d="M3 18C2.45 18 1.97933 17.8043 1.588
                                17.413C1.196
                                17.021 1 16.55 1
                                16V3H0V1H5V0H11V1H16V3H15V16C15
                                16.55
                                14.8043 17.021 14.413 17.413C14.021 17.8043
                                13.55
                                18
                                13
                                18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9
                                14H11V5H9V14Z"

              />
            </svg>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-container
    *ngIf="
      !loading && !templates.length
    "
  >
    <div class="no-data-wrapper">
      <img [style.width]="!templates.length && !isSearchFilterOn ? '139px' : '200px'" height="225px" [src]="!templates.length && !isSearchFilterOn ? '/assets/icons/printer.svg' : '/assets/icons/empty-search.svg'" />
      <p class="no-data-title">No templates</p>
      <p *ngIf="!templates.length && !isSearchFilterOn">
        Press the button at the top right corner <br />  to create your first template.
      </p>
      <p *ngIf="!templates.length && isSearchFilterOn">
        We are sorry, we couldn’t find any matching <br /> results. Please try
        different search.
      </p>
    </div>
  </ng-container>

  <div *ngIf="loading" style="margin-top: 33px;">
    <table class="si-table">
      <tbody>
        <tr *ngFor="let i of [1, 2, 3, 4, 5, 6]">
          <td>
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{
                height: '15px',
                width: '350px',
                'border-radius': '3px'
              }"
            >
            </ngx-skeleton-loader>
          </td>
          <td class="text-right">
            <ngx-skeleton-loader count="1" appearance="circle">
            </ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
